export default __webpack_public_path__ + "static/media/i-share.ca0209b2.svg";